<template>
    <div>
      <div class="search-info">
          <span class="search-info__text" v-if="searchParams.key != isAllSearch">
              {{ getParamName(searchParams.param) }}: <strong>{{ searchParams.key }}</strong>
          </span>
          <span class="search-info__text">
              {{ $lang.search.info.count }}: <strong v-if="appIsRunning" v-bind:lang="$lang.language" v-thousand-number="searchResultsNum">{{ searchResultsNum }}</strong>
          </span>
      </div>
      <div class="is-clearfix" v-if="searchParams.key != isAllSearch">
        <a v-on:click.prevent="showAll()" class="search-info__all is-pulled-right">{{ $lang.search.info.clear }}</a>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as searchModule from '../../scripts/modules/search'
import configData from '../../config'

export default {
  name: 'search-info',
  methods: {
    getParamName(param) {
      param = typeof param !== typeof undefined ? param : ''

      for (let i in this.$lang.search.form.select.params) {
        if (this.$lang.search.form.select.params[i]['val'] == param) {
          return this.$lang.search.form.select.params[i]['name']
        }
      }
    },
    showAll() {
      this.$store.commit('RESET_SEARCH_PARAMS_KEY')
      this.$store.commit('RESET_SEARCH_PARAMS_PARAM')
      searchModule.resetSearchQuery()
    }
  },
  computed: {
    ...mapGetters({
        searchParams: 'GET_SEARCH_PARAMS',
        searchResultsNum: 'GET_SEARCH_RESULTS_NUM',
        appIsRunning: 'GET_APP_IS_RUNNING'
    }),
    isAllSearch: function() {
      return configData().params.search.default.key
    }
  }
}
</script>



// WEBPACK FOOTER //
// SearchInfo.vue?47551d93